module.exports = __webpack_public_path__ + "img/3.430041b6.jpeg";